import { render, staticRenderFns } from "./PlannerTableColumn.vue?vue&type=template&id=33ec708b&scoped=true"
import script from "./PlannerTableColumn.vue?vue&type=script&lang=js"
export * from "./PlannerTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ec708b",
  null
  
)

export default component.exports